// Generated by purs version 0.15.15
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_State_Trans from "../Control.Monad.State.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Effect_AVar from "../Effect.AVar/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_AVar from "../Effect.Aff.AVar/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Effect_Aff.functorAff);
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT);
var lift1 = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT);
var lift2 = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_State_Trans.monadTransStateT);
var Killed = /* #__PURE__ */ (function () {
    function Killed(value0) {
        this.value0 = value0;
    };
    Killed.create = function (value0) {
        return new Killed(value0);
    };
    return Killed;
})();
var Filled = /* #__PURE__ */ (function () {
    function Filled(value0) {
        this.value0 = value0;
    };
    Filled.create = function (value0) {
        return new Filled(value0);
    };
    return Filled;
})();
var Empty = /* #__PURE__ */ (function () {
    function Empty() {

    };
    Empty.value = new Empty();
    return Empty;
})();
var manageAVarAVarAff = {
    empty: Effect_Aff_AVar.empty,
    "new": Effect_Aff_AVar["new"],
    kill: function (message) {
        return Effect_Aff_AVar.kill(Effect_Exception.error(message));
    },
    read: Effect_Aff_AVar.read,
    tryRead: Effect_Aff_AVar.tryRead,
    take: Effect_Aff_AVar.take,
    tryTake: Effect_Aff_AVar.tryTake,
    put: Effect_Aff_AVar.put,
    tryPut: Effect_Aff_AVar.tryPut,
    status: function (avar) {
        return mapFlipped(Effect_Aff_AVar.status(avar))(function (v) {
            if (v instanceof Effect_AVar.Filled) {
                return new Filled(v.value0);
            };
            if (v instanceof Effect_AVar.Empty) {
                return Empty.value;
            };
            if (v instanceof Effect_AVar.Killed) {
                return new Killed(Effect_Exception.message(v.value0));
            };
            throw new Error("Failed pattern match at WE.Class.AVar (line 67, column 36 - line 70, column 42): " + [ v.constructor.name ]);
        });
    },
    Monad0: function () {
        return Effect_Aff.monadAff;
    }
};
var tryTake = function (dict) {
    return dict.tryTake;
};
var tryRead = function (dict) {
    return dict.tryRead;
};
var tryPut = function (dict) {
    return dict.tryPut;
};
var take = function (dict) {
    return dict.take;
};
var status = function (dict) {
    return dict.status;
};
var read = function (dict) {
    return dict.read;
};
var put = function (dict) {
    return dict.put;
};
var $$new = function (dict) {
    return dict["new"];
};
var kill = function (dict) {
    return dict.kill;
};
var isFilled = function (dictManageAVar) {
    var mapFlipped1 = Data_Functor.mapFlipped((((dictManageAVar.Monad0()).Bind1()).Apply0()).Functor0());
    var status1 = status(dictManageAVar);
    return function (avar) {
        return mapFlipped1(status1(avar))(function (v) {
            if (v instanceof Filled) {
                return true;
            };
            return false;
        });
    };
};
var empty = function (dict) {
    return dict.empty;
};
var manageAVarExceptT = function (dictManageAVar) {
    var Monad0 = dictManageAVar.Monad0();
    var lift3 = lift(Monad0);
    var new1 = $$new(dictManageAVar);
    var kill1 = kill(dictManageAVar);
    var read1 = read(dictManageAVar);
    var tryRead1 = tryRead(dictManageAVar);
    var take1 = take(dictManageAVar);
    var tryTake1 = tryTake(dictManageAVar);
    var put1 = put(dictManageAVar);
    var tryPut1 = tryPut(dictManageAVar);
    var status1 = status(dictManageAVar);
    var monadExceptT = Control_Monad_Except_Trans.monadExceptT(Monad0);
    return {
        empty: lift3(empty(dictManageAVar)),
        "new": function (initial) {
            return lift3(new1(initial));
        },
        kill: function (message) {
            return function (avar) {
                return lift3(kill1(message)(avar));
            };
        },
        read: function (avar) {
            return lift3(read1(avar));
        },
        tryRead: function (avar) {
            return lift3(tryRead1(avar));
        },
        take: function (avar) {
            return lift3(take1(avar));
        },
        tryTake: function (avar) {
            return lift3(tryTake1(avar));
        },
        put: function (v) {
            return function (avar) {
                return lift3(put1(v)(avar));
            };
        },
        tryPut: function (v) {
            return function (avar) {
                return lift3(tryPut1(v)(avar));
            };
        },
        status: function (avar) {
            return lift3(status1(avar));
        },
        Monad0: function () {
            return monadExceptT;
        }
    };
};
var manageAVarReaderT = function (dictManageAVar) {
    var Monad0 = dictManageAVar.Monad0();
    var lift3 = lift1(Monad0);
    var new1 = $$new(dictManageAVar);
    var kill1 = kill(dictManageAVar);
    var read1 = read(dictManageAVar);
    var tryRead1 = tryRead(dictManageAVar);
    var take1 = take(dictManageAVar);
    var tryTake1 = tryTake(dictManageAVar);
    var put1 = put(dictManageAVar);
    var tryPut1 = tryPut(dictManageAVar);
    var status1 = status(dictManageAVar);
    var monadReaderT = Control_Monad_Reader_Trans.monadReaderT(Monad0);
    return {
        empty: lift3(empty(dictManageAVar)),
        "new": function (initial) {
            return lift3(new1(initial));
        },
        kill: function (message) {
            return function (avar) {
                return lift3(kill1(message)(avar));
            };
        },
        read: function (avar) {
            return lift3(read1(avar));
        },
        tryRead: function (avar) {
            return lift3(tryRead1(avar));
        },
        take: function (avar) {
            return lift3(take1(avar));
        },
        tryTake: function (avar) {
            return lift3(tryTake1(avar));
        },
        put: function (v) {
            return function (avar) {
                return lift3(put1(v)(avar));
            };
        },
        tryPut: function (v) {
            return function (avar) {
                return lift3(tryPut1(v)(avar));
            };
        },
        status: function (avar) {
            return lift3(status1(avar));
        },
        Monad0: function () {
            return monadReaderT;
        }
    };
};
var manageAVarStateT = function (dictManageAVar) {
    var Monad0 = dictManageAVar.Monad0();
    var lift3 = lift2(Monad0);
    var new1 = $$new(dictManageAVar);
    var kill1 = kill(dictManageAVar);
    var read1 = read(dictManageAVar);
    var tryRead1 = tryRead(dictManageAVar);
    var take1 = take(dictManageAVar);
    var tryTake1 = tryTake(dictManageAVar);
    var put1 = put(dictManageAVar);
    var tryPut1 = tryPut(dictManageAVar);
    var status1 = status(dictManageAVar);
    var monadStateT = Control_Monad_State_Trans.monadStateT(Monad0);
    return {
        empty: lift3(empty(dictManageAVar)),
        "new": function (initial) {
            return lift3(new1(initial));
        },
        kill: function (message) {
            return function (avar) {
                return lift3(kill1(message)(avar));
            };
        },
        read: function (avar) {
            return lift3(read1(avar));
        },
        tryRead: function (avar) {
            return lift3(tryRead1(avar));
        },
        take: function (avar) {
            return lift3(take1(avar));
        },
        tryTake: function (avar) {
            return lift3(tryTake1(avar));
        },
        put: function (v) {
            return function (avar) {
                return lift3(put1(v)(avar));
            };
        },
        tryPut: function (v) {
            return function (avar) {
                return lift3(tryPut1(v)(avar));
            };
        },
        status: function (avar) {
            return lift3(status1(avar));
        },
        Monad0: function () {
            return monadStateT;
        }
    };
};
export {
    Killed,
    Filled,
    Empty,
    empty,
    isFilled,
    kill,
    $$new as new,
    put,
    read,
    status,
    take,
    tryPut,
    tryRead,
    tryTake,
    manageAVarAVarAff,
    manageAVarReaderT,
    manageAVarExceptT,
    manageAVarStateT
};
//# sourceMappingURL=index.js.map
